import * as madnes from "../../framework/src/engine/madnes/madnes";

import {madnes_set_win_factors} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_audio_volume, madnes_set_default_volume} from "../../framework/src/engine/madnes/madnes_audio";
import {mv81_end_round_recalced, mv81_rotate_run} from "../mv81_core";
import {
    mv81_infomenu_close,
    mv81_infomenu_home,
    mv81_infomenu_init,
    mv81_infomenu_left,
    mv81_infomenu_open, mv81_infomenu_right, mv81_infomenu_update,
    mv81_print_desk,
    openinfo
} from "../mv81_reels";
import {mv81_print_reels} from "../mv81_core_printer";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";


export const infotexts_languages = [
    "bg", "cs", "de", "en", "es", "fi", "fr", "hr", "it", "no", "pl", "ro", "ru", "sk", "sr", "sv", "tr", "pt", "es-mx", "nl"
];

export function initGame(gameset) {

    madnes.set_ico_size(200, 184);

    madnes_set_win_factors(25, 50, 125);

    madnes_set_sprite("coins", 152, 152);

    madnes_set_sprite('_sprite', 320, 280);
    madnes_set_sprite('_blur', 320, 280);

    madnes_set_sprite('bigwin_sprite', 758, 510);

    madnes_set_default_volume(0.8);
    madnes_set_audio_volume("reel", 0.6);

    madnes_set_default_volume(0.8);

}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced(eventName, data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            infomenu_update();
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function on_set_bet() {
    infomenu_update();
}

export function game_start() {
    mv81_rotate_run()
}

export function print_desk() {
    mv81_print_desk()
}

export function print_reels() {
    mv81_print_reels();
}

export function infomenu_init() {
    mv81_infomenu_init();
}

export function infomenu_open() {
    mv81_infomenu_open();
}

export function infomenu_close() {
    mv81_infomenu_close();
}

export function infomenu_home() {
    mv81_infomenu_home();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    mv81_infomenu_left();
}

export function infomenu_right() {
    mv81_infomenu_right();
}

export function infomenu_update() {
    mv81_infomenu_update();
}

export function end_round_recalced(eventName, {autorun}) {
    mv81_end_round_recalced();

    if(!autorun) {
        end_round_no_autostart();
    }
}

export function end_round_no_autostart() {}

export function freespins_end_round(eventName, {ended}) {}

export function get_preinfo() {}

export function preinfo_close() {}